import type { Middleware } from 'redux';

// Automatically add timestamps to all actions
export const timestampMiddleware: Middleware = () => (next) => (action) =>
  next({
    ...action,
    timestamp: Date.now(),
  });
